export type RemoteRetroHuntAction = "stop" | "pause" | "resume";

type Parameters = {
  bucket: string;
  folder: string;
  file_type_group: Array<string>;
  classification: Array<string>;
};

export type RemoteRetroHuntActionResponse = {
  id: string;
  status: string;
  start_time: Date;
  last_update: Date;
  parameters: Parameters;
};

export type RemoteRetroHuntPayload = {
  bucket: string;
  folder?: string | null;
  newer_than?: string | null;
};
